import { render, staticRenderFns } from "./BaseInfoBarItem.vue?vue&type=template&id=d144f9e8"
import script from "./BaseInfoBarItem.vue?vue&type=script&lang=js"
export * from "./BaseInfoBarItem.vue?vue&type=script&lang=js"
import style0 from "./BaseInfoBarItem.vue?vue&type=style&index=0&id=d144f9e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports